import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=9fb85034&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=9fb85034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb85034",
  null
  
)

export default component.exports